export default function stripUndefined(obj) {
    const o = { ...obj };
    Object.keys(o).forEach(key => o[key] === undefined && delete o[key]);
    return o;
}
